// removed by extract-text-webpack-plugin
module.exports = {"unfocused":"_2kkfg","focused":"_1vaWv"};


//////////////////
// WEBPACK FOOTER
// ./app/components/styled-text-editor/focus-theme.scss
// module id = 818
// module chunks = 3 4 5 6 7